import vuex from 'vuex'
import vue from 'vue'
import { get_token, set_token, delete_token } from '@/utils/token'
import { get_type, set_type, delete_type } from '@/utils/BTN_rights'
import { reqUserInfo, reqAllAdminInfo } from '@api/user'
vue.use(vuex)
const store = new vuex.Store({
    state: {
        userName: '',
        token: get_token(),
        userType: get_type(),
        phone: '',
        parentName: '',
        courseIds: '',
        canAddTelegram:'',
        isShowLoading: false,
        checkGroup:false,
    },
    mutations: {
        setToken(state, payLoad) {
            state.token = payLoad
            set_token(payLoad)
        },
        setUserInfo(state, payLoad) {
            state.userName = payLoad.account
            state.userType = payLoad.userType
            state.parentName = payLoad.parentName
            state.courseIds = payLoad.emailCode
            state.canAddTelegram = payLoad.canAddTelegram
            set_type(payLoad.userType)
        },
        setCheckGroup(state, value) {
            state.checkGroup = value;
        },
        delete_user(state) {
            state.userName = '',
                delete_token()
            delete_type()
        },
        setPhoneNumber(state, { clause }) {
            state.phone = clause
        },
        setLoading(state, payLoad) {
            console.log('payLoad', payLoad);

            state.isShowLoading = payLoad
        }
    },
    actions: {
        /* 请求用户信息 */
        async get_userInfo() {
            try {
                const result = await reqUserInfo()
                store.commit('setUserInfo', result)
            } catch (error) {
                console.log('error', error);
                return new error('')
            }
        },
        /* 请求联系我们电话号码 */
        async get_phone() {
            try {
                const result = await reqAllAdminInfo()
                // console.log('get_phone',result?.[0]);
                store.commit('setPhoneNumber', result?.[0])
            } catch (error) {
                console.log('error', error);
            }
        }
    },
    getters: {
    },
})
export default store